module.exports = __webpack_public_path__ + "media/images/sunfix_logo_white-ddadc49c1ae3493587860c5bd986a3dc.svg";